<template>
  <div class="form-group">
    <label
      v-bind:class="{
        'text-danger': current.errors && current.errors.producto,
      }"
      >{{ title }}</label
    >
    <div class="row">
      <div class="col-11">
        <v-select
          label="sku"
          v-model="current.producto"
          :filterable="false"
          @input="$emit('input')"
          :disabled="disabled"
          :options="productos"
          @search="onSearch"
        >
          <template slot="no-options">Producto...</template>
          <template slot="option" slot-scope="option">
            <div class="d-center">
              <img :src="option.image" />
              {{ option.sku }} - {{ option.nombre }}
            </div>
          </template>
          <template slot="selected-option" slot-scope="option">
            <div class="selected d-center">
              <img :src="option.image" />
              {{ option.sku }} - {{ option.nombre }}
            </div>
          </template>
        </v-select>
      </div>
      <div class="col-1" style="padding: 0px">
        <div v-if="showModal" class="modal-popup">
          <div>
            <!-------------------- Tabla de REsultados -------------------->
            <table class="table table-hover">
              <thead>
                <tr>
                  <th class="text-center">Tienda</th>
                  <th class="text-center">Sol. auto</th>
                  <th class="text-center">Compra Local</th>
                  <th class="text-center">Existencia</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="det in producto_tienda.results" v-bind:key="det.id">
                  <td class="text-center">{{ det.tienda }}</td>
                  <td class="text-center">
                    <div
                      v-bind:class="{
                        green: det.sol_auto == true,
                        red: det.sol_auto == false,
                      }"
                      class="status-pill"
                    ></div>
                  </td>
                  <td class="text-center">
                    <div
                      v-bind:class="{
                        green: det.compra_local == true,
                        red: det.compra_local == false,
                      }"
                      class="status-pill"
                    ></div>
                  </td>
                  <td class="text-center">
                    {{ det.existencia }}
                  </td>
                </tr>
              </tbody>
            </table>
            <!-------------------- END - Basic Table -------------------->
          </div>
          <button @click="showModal = false" class="btn btn-dark btn-md">
            <i class="fas fa-door-open"></i>
          </button>
        </div>
        <a
          v-if="current.producto && disabled_view == false"
          @click="mostrarDetalle()"
          class="btn btn-info btn-sm"
        >
          <i class="fas fa-eye"></i
        ></a>
        <button
          v-if="!current.producto && disabled_view == false"
          :disabled="true"
          @click="mostrarDetalle()"
          class="btn btn-info btn-sm"
        >
          <i class="fas fa-eye"></i>
        </button>
      </div>
    </div>
    <small
      v-if="current.errors && current.errors.producto"
      class="form-text text-danger"
      >{{ current.errors.producto[0] }}</small
    >
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import DynamicService from "@/services/commons/DynamicService";

export default {
  props: {
    current: {
      type: Object,
      required: true,
    },
    title: {
      type: String,
      default: "Producto",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    tienda: {
      type: String,
      required: false,
    },
    disabled_view: {
      type: Boolean,
      required: false,
    },
  },
  data() {
    return {
      showModal: false,
      params: {},
      producto_tienda: {
        errors: {},
      },
    };
  },
  computed: {
    ...mapGetters({
      productos: "catalogos/productos",
    }),
  },
  mounted() {
    this.$store.dispatch("catalogos/productos", {
      activo: true,
      quitar_paginacion: true,
    });
  },
  methods: {
    mostrarDetalle() {
      let self = this;
      if (this.showModal == true) {
        this.showModal = false;
        return;
      }
      if (self.producto && self.params.producto == self.current.producto.sku) {
        self.showModal = true;
        return;
      }
      self.params.producto = self.current.producto.sku;
      if (self.current.tienda) {
        self.params.tienda = self.current.tienda;
      }
      DynamicService.fetch("cat", "producto-tienda", self.params).then((response) => {
        self.producto_tienda = response.data;
        console.log(self.producto_tienda.results);
        self.showModal = true;
      });
    },
    onSearch(search, loading) {
      self.showModal = false;
      self.producto_tienda = "";
      loading(true);
      this.search(loading, search, this);
    },
    search: _.debounce((loading, search, vm) => {
      if (search == "" || search == null) {
        loading(false);
        return;
      }
      let that = this;
      vm.$store.dispatch("catalogos/productos", {
        page: 1,
        activo: true,
        quitar_paginacion: true,
        "filter[search]": search,
      });
      loading(false);
    }, 350),
  },
};
</script>
